const sources = [
    {
        name: 'environmentModel',
        type: 'gltfModel',
        path: 'models/World/environment.glb',
    },
    {
        name: 'environmentTexture',
        type: 'texture',
        path: 'models/World/baked_environment.jpg',
    },
    {
        name: 'monitorSmudgeTexture',
        type: 'texture',
        path: 'textures/monitor/layers/compressed/smudges.jpg',
    },
    {
        name: 'monitorShadowTexture',
        type: 'texture',
        path: 'textures/monitor/layers/compressed/shadow-compressed.png',
    },
    {
        name: 'mouseDown',
        type: 'audio',
        path: 'audio/mouse/mouse_down.mp3',
    },
    {
        name: 'mouseUp',
        type: 'audio',
        path: 'audio/mouse/mouse_up.mp3',
    },
    {
        name: 'keyboardKeydown1',
        type: 'audio',
        path: 'audio/keyboard/key_1.mp3',
    },
    {
        name: 'keyboardKeydown2',
        type: 'audio',
        path: 'audio/keyboard/key_2.mp3',
    },
    {
        name: 'keyboardKeydown3',
        type: 'audio',
        path: 'audio/keyboard/key_3.mp3',
    },
    {
        name: 'keyboardKeydown4',
        type: 'audio',
        path: 'audio/keyboard/key_4.mp3',
    },
    {
        name: 'keyboardKeydown5',
        type: 'audio',
        path: 'audio/keyboard/key_5.mp3',
    },
    {
        name: 'keyboardKeydown6',
        type: 'audio',
        path: 'audio/keyboard/key_6.mp3',
    },
    {
        name: 'startup',
        type: 'audio',
        path: 'audio/startup/startup.mp3',
    },
    {
        name: 'office',
        type: 'audio',
        path: 'audio/atmosphere/office.mp3',
    },
    {
        name: 'ccType',
        type: 'audio',
        path: 'audio/cc/type.mp3',
    },
    {
        name: 'officeDeskModel',
        type: 'gltfModel',
        path: 'models/Office/OfficeCombined7.glb',
    },
    {
        name: 'cactusTexture',
        type: 'texture',
        path: 'textures/Office/M_Cactus_1024_Colour.jpeg',
    },
    {
        name: 'fileboxTexture',
        type: 'texture',
        path: 'textures/Office/M_Filebox_1024_Colour.jpeg',
    },
    {
        name: 'computerTexture',
        type: 'texture',
        path: 'textures/Office/M_Computer_2048_Colour.jpeg',
    },
    {
        name: 'sigaTexture',
        type: 'texture',
        path: 'textures/Office/M_Sigarettes_512_Colour_JPEG.jpeg',
    },
    {
        name: 'tableTexture',
        type: 'texture',
        path: 'textures/Office/M_Table_2048_Colour.jpeg',
    },
    {
        name: 'tapeTexture',
        type: 'texture',
        path: 'textures/Office/M_TapeRecorder_1024_Colour.jpeg',
    },
    {
        name: 'tapeGlassTexture',
        type: 'texture',
        path: 'textures/Office/M_TapeRecorder_Tape_Rotors_Glass_1024_Colour-M_TapeRecorder_.png',
    },
    {
        name: 'clipboardTexture',
        type: 'texture',
        path: 'textures/Office/M_Clipboard_Notepad_1024_Colour.jpeg',
    },
    {
        name: 'officeStoolBinTexture',
        type: 'texture',
        path: 'textures/Office/M_OfficeStool_Bin_2048_Colour-M_OfficeStool_Bin_2048_Opacity.png',
    },
    {
        name: 'lampsTexture',
        type: 'texture',
        path: 'textures/Office/M_Lamps_CCTV_2048_Colour_jpg-M_Lamps_CCTV_2048_Opacity_jpg.png',
    },
    {
        name: 'photoTexture',
        type: 'texture',
        path: 'textures/Office/M_Office_PinBoard_Photo_Notepad_1024_Colour-M_Office_PinBoar.png',
    },
];
export default sources;
